<template>
  <CustomInput :field="{...deafult_input, readonly: readonly, value: new String(value)}" @update="update"/>
</template>
  
<script>
  import CustomInput from '@/components/inputs/CustomInput';
  export default {
    components: {
      CustomInput
    },
      
    name: 'StringProps',
      
    props: {
      name: {},
      value: {},
      readonly: Boolean,
    },
      
    data: () => ({
      deafult_input: {
        id: '',
        label: '',
        required: false,
        value: '',
        readonly: false,
        cols: 4,
        class: null,
        component: 'TextInput',
        placeholder: "",
        hide_details: true,
      }
    }),
      
    computed: {
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
        this.$emit('update',value);
      }
    },
  
  }
</script>